import { NavTabs } from "@/components/layout/nav-tabs";
import { PageHeader } from "@/components/layout/page-header";

const TABS = [
  { label: "Widgets", href: "/widgets" },
  { label: "Data Sources", href: "/widgets/data-sources" },
];

interface SectionHeaderProps {
  actions?: React.ReactNode;
}

/**
 * Renders as siblings, not inside a wrapper: PageHeader is sticky, and a
 * wrapper only as tall as the header and tabs would unpin it after a short
 * scroll. The tabs' negative margin cancels the pages' `gap-4`.
 */
export function SectionHeader({ actions }: SectionHeaderProps) {
  return (
    <>
      <PageHeader title="Widgets" actions={actions} />
      <NavTabs label="Widgets" tabs={TABS} className="-mt-4" />
    </>
  );
}
